import { Injectable } from "@angular/core";
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpHeaders,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { UserService } from "./services/user.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(public user: UserService) { }

    intercept(
        request: HttpRequest<unknown>,
        next: HttpHandler
    ): Observable<HttpEvent<unknown>> {
        if (request.url.includes('spotify') || request.url.includes('apple')) {
            // no chnage require
        } else {
            if (this.user.token) {
                request = request.clone({
                    headers: request.headers.set(
                        "Authorization",
                        this.user.token
                    ),
                });
            }
        }

        return next.handle(request);
    }
}
